import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CgPageLoader from 'modules/Common/layout/CgPageLoader';
import { useMyFirm } from '../hooks/useMyFirm';
import VerifierNotice from './VerifierNotice';

export const VERIFIER_SETUP_PATH = '/verifier/setup';

// VF22: until the firm's Annex §1.3 details are in, its Admin is sent to setup (and back to the
// page they asked for). Members are never stopped — a member cannot answer for the firm — they
// see a notice instead.
const VerifierSetupGate = ({ children }) => {
  const { t } = useTranslation('app');
  const location = useLocation();
  const { data, isLoading } = useMyFirm();

  if (isLoading) return <CgPageLoader ariaLabel={t('verifier.loading', 'Loading your firm')} />;
  const firm = data?.firm;
  if (!firm || firm.setupComplete) return children;

  if (data.isAdmin) {
    const next = `${location.pathname}${location.search}`;
    return <Redirect to={`${VERIFIER_SETUP_PATH}?next=${encodeURIComponent(next)}`} />;
  }
  return (
    <>
      <VerifierNotice className="mx-4 mt-4">
        {t(
          'verifier.setup.memberNotice',
          "Your firm's administrator still needs to add the firm's accreditation details.",
        )}
      </VerifierNotice>
      {children}
    </>
  );
};

export default VerifierSetupGate;
